import { render } from "./GroupEditComponent.vue?vue&type=template&id=86e82fdc&scoped=true"
import script from "./GroupEditComponent.vue?vue&type=script&lang=js"
export * from "./GroupEditComponent.vue?vue&type=script&lang=js"

import "./GroupEditComponent.vue?vue&type=style&index=0&id=86e82fdc&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86e82fdc"]])

export default __exports__